<template>
  <div>
    <Navbar appTitle="批量处理" />
    <div
      class="search-content wrap-apply"
      :style="{
        top: GLOBAL.currentEnvironment ? '0' : '',
        height: GLOBAL.currentEnvironment ? '100vh' : 'calc(100vh - 1.12rem)',
        paddingBottom: GLOBAL.currentEnvironment ? '0.66rem' : '',
      }"
    >
      <div v-for="(g, i) in handleList" :key="i">
        <van-cell-group style="margin-top: 0.1rem">
          <p class="title">不合格品处理({{ i + 1 }})</p>
          <div class="bottomLine"></div>
          <p class="label FormTit"><span></span>工单编号</p>
          <van-field disabled v-model="g.orderCode" placeholder="请输入" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>生产物料</p>
          <van-field disabled v-model="g.goodsName" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>工序</p>
          <van-field disabled v-model="g.processName" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>批次编号</p>
          <div style="padding:0.1rem 0.16rem"><batch-production :code="g.batchCode" :id="g.batchId"></batch-production></div>
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>操作人</p>
          <van-field disabled v-model="g.operatorIdText" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label FormTit"><span></span>提交时间</p>
          <van-field disabled v-model="g.applyTime" />
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label required FormTit"><span></span>处理方式</p>
          <van-field
            placeholder="请选择"
            v-model="g.handleTypeText"
            @click="showPop(i)"
          >
            <div
              slot="right-icon"
              v-show="!!g.handleTypeText"
              @click.stop="showPop(i, 'del')"
            >
              <img
                src="~@/assets/img/filedClear.png"
                alt=""
                style="width: 0.16rem"
              />
            </div>
          </van-field>
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label required FormTit"><span></span>处理数量</p>
          <van-field
            placeholder="请输入"
            @input="(e) => inputNum(e, i)"
            v-model="g.num"
          >
            <template #button>
              <span>{{ g.reportWorkUnitText }}</span>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <p class="label required FormTit"><span></span>不合格工序</p>
          <van-field
            :is-link="!g.faieldProcessIdText"
            placeholder="请选择"
            readonly
            v-model="g.faieldProcessIdText"
            @click="showPopFP(i)"
          >
            <div
              slot="right-icon"
              v-show="!!g.faieldProcessIdText"
              @click.stop="showPopFP(i, 'del')"
            >
              <img
                src="~@/assets/img/filedClear.png"
                alt=""
                style="width: 0.16rem"
              />
            </div>
          </van-field>
          <div class="bottomLine"></div>
        </van-cell-group>
        <van-cell-group>
          <p class="label required FormTit"><span></span>不合格操作人</p>
          <van-field-checkbox
            :supportClear="true"
            placeholder="请选择"
            v-model="g.failedOperatorIdText"
            :columns="g.optionsFPor"
            :option="{ label: 'failedOperatorName', value: 'failedOperatorId' }"
            @confirm="(e) => confirmOperator(e, i)"
          />
          <!-- <van-field
            :is-link="!g.failedOperatorIdText"
            placeholder="请选择"
            readonly
            v-model="g.failedOperatorIdText"
            @click="showPopFPor(i)"
          >
            <div
              slot="right-icon"
              v-show="!!g.failedOperatorIdText"
              @click.stop="showPopFPor(i, 'del')"
            >
              <img
                src="~@/assets/img/filedClear.png"
                alt=""
                style="width: 0.16rem"
              />
            </div>
          </van-field> -->
          <div class="bottomLine"></div>
        </van-cell-group>
      </div>
      <div class="search-bottoms">
        <!-- <span class="btnconfirm" @click="btnConfirm">确定</span> -->
        <van-button
          type="info"
          :loading="loadingSubmit"
          class="btnconfirm"
          loading-text="提交中..."
          @click="btnConfirm"
          >提交</van-button
        >
      </div>
    </div>
    <van-popup v-model="visibles" position="bottom">
      <van-picker
        :columns="options"
        @confirm="handleConfirm"
        @cancel="visibles = false"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="visiblesFP" position="bottom">
      <van-picker
        :columns="optionsFP"
        @confirm="handleConfirmFP"
        @cancel="visiblesFP = false"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="visiblesFPor" position="bottom">
      <van-picker
        :columns="optionsFPor"
        @confirm="handleConfirmFPor"
        @cancel="visiblesFPor = false"
        show-toolbar
      />
    </van-popup>
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
import { messNotQualityHandleIinfoHandle } from "@/api/system";
import { commafy, clearNoNum } from "@/utils/util";
import { APILX } from "@/api/requestLx";
import VanFieldCheckbox from "@/components/ActionSheet/VanFieldCheckbox";
import { forEach } from "lodash";
import BatchProduction from '@/components/BatchProduction'

import { queryOperatorByFailedProcessId } from "@/api/mobile";
export default {
  name: "materialRequisitionForm", //领料单
  components: {
    Navbar,
    VanFieldCheckbox,
    BatchProduction
  },

  data() {
    return {
      commafy,
      loadingSubmit: false,
      visibles: false,
      visiblesFP: false, //不合格工序
      optionsFP: [], //不合格工序下拉数据
      visiblesFPor: false, //不合格工序操作人弹窗
      optionsFPor: [], //不合格工序操作人下拉数据
      handleList: [],
      options: [
        { text: "返修", value: "repair" },
        { text: "让步接收", value: "compromise" },
        { text: "报废", value: "scrap" },
      ],
      handleTypeText: "",
      faieldProcessIdText: "", //不合格工序
      failedOperatorIdText: "", //不合格工序操作人
      listIndex: 0,
    };
  },
  beforeDestroy() {
    localStorage.removeItem("bis_UNQUALIFIEDS");
  },
  created() {
    this.getDetail();
  },
  methods: {
    // 查不合格工序下拉
    getFailedList(i) {
      let par = {
        orderId: this.handleList[i].orderId,
        taskId: this.handleList[i].taskId,
      };
      APILX.queryProcessByOrderTaskId(par).then((res) => {
        console.log(res.result, "res.result");
        this.optionsFP = res.result || [];
        this.optionsFP.forEach((item) => {
          item.text = item.failedProcessName;
          item.value = item.failedProcessId;
        });
        console.log(this.optionsFP, "this.optionsFP");
      });
    },

    handleConfirmFPor(v) {
      var i = this.listIndex;
      console.log(v, i, "vvvvvvvvvv");
      if (!v) {
        this.handleList[i].failedOperatorIdText = [];
        this.handleList[i].failedOperatorId = '';
        this.visiblesFPor = false;
        this.$forceUpdate();
        return;
      }
      this.handleList[i].failedOperatorIdText = v.text;
      this.handleList[i].failedOperatorId = v.value;
      this.visiblesFPor = false;
    },

    showPop(i,del) {
      this.listIndex = i;
      if (del == "del") {
        this.handleConfirm("");
      } else {
        this.visibles = true;
      }
    },
    showPopFP(i, del) {
      this.listIndex = i;
      this.getFailedList(i);
      if (del == "del") {
        this.handleConfirmFP("");
      } else {
        this.visiblesFP = true;
      }
    },
    showPopFPor(i, del) {
      console.log(i, "showPopFPor");
      if(this.handleList[i].failedProcessId == ''){
        this.$toast(`请先选择不合格工序`)
        return
      }
      if (this.listIndex === i) {
        this.listIndex = i;
      } else {
        this.listIndex = i;
        this.optionsFPor = [];
      }
      if (del == "del") {
        this.handleConfirmFPor("");
      } else {
        if (this.optionsFPor.length == 0) {
          this.getFailedList(i);
          setTimeout(() => {
            let item = this.optionsFP.filter(
              (each) =>
                each.failedProcessId == this.handleList[i].failedProcessId
            );
            let optionsFPor = [];
            item[0].failedOperatorList.forEach((item) => {
              item.text = item.failedOperatorName;
              item.value = item.failedOperatorId;
              optionsFPor.push(item);
            });
            this.optionsFPor = optionsFPor;
            this.visiblesFPor = true;
          }, 500);

          // this.$toast("请先选择不合格工序");
        } else {
          this.visiblesFPor = true;
        }
      }
    },
    // 处理数量格式化
    inputNum(e, i) {
      this.handleList[i].num = clearNoNum(e);
    },
    // 选择处理方式
    handleConfirm(v) {
      var i = this.listIndex;
      if (!v) {
        this.handleList[i].handleTypeText = "";
        this.handleList[i].handleType = "";
        this.visibles = false;
        this.$forceUpdate();
      }
      this.handleList[i].handleTypeText = v.text;
      this.handleList[i].handleType = v.value;
      this.visibles = false;
    },
    // 选择不合格品处理方式
    handleConfirmFP(v) {
      var i = this.listIndex;
      console.log(v, "vvvvvvvvvv");
      if (!v) {
        this.handleList[i].faieldProcessIdText = "";
        this.handleList[i].failedProcessId = "";
        this.handleList[i].failedTaskId = "";
        this.visiblesFP = false;
        this.$forceUpdate();
        return;
      }
      this.handleList[i].faieldProcessIdText = v.text;
      this.handleList[i].failedProcessId = v.value;
      this.handleList[i].failedTaskId = v.failedTaskId;
      this.handleList[i].failedOperatorIdText = this.handleList[i].operatorId.split(',');
      this.handleList[i].failedOperatorId = this.handleList[i].operatorId;
      this.getReportTeam(this.handleList[i], i)
      // console.log(v)
      // this.handleTypeText = v.text
      this.visiblesFP = false;
    },
    // 查不合格工序操作人下拉
    getFPor(v) {
      this.handleConfirmFPor("");
      if (!v) {
        this.optionsFPor = [];
        return;
      }
      console.log(v, "不合格操作人");

      let optionsFPor = [];
      v.forEach((item) => {
        console.log(item, "0.0");
        item.text = item.failedOperatorName;
        item.value = item.failedOperatorId;
        optionsFPor.push(item);
      });
      console.log(optionsFPor, "optionsFPoroptionsFPor");
      this.optionsFPor = optionsFPor;
      if (this.optionsFPor.length == 1) {
        this.handleConfirmFPor(this.optionsFPor[0]);
      }
      console.log(this.optionsFPor, "this.optionsFPor");
    },
    // 查不合格工序操作人下拉
    getReportTeam(e, i) {
      queryOperatorByFailedProcessId({failedProcessId: e.processId, orderId: e.orderId}).then(res => {
        if (res.result) {
          this.handleList[i].optionsFPor = res.result
          this.$forceUpdate()
        }
      })
    },
    confirmOperator(v, i) {
      if (!v) {
        this.handleList[i].failedOperatorIdText = []
        this.handleList[i].failedOperatorId = ''
      } else {
        this.handleList[i].failedOperatorIdText = v
        this.handleList[i].failedOperatorId = v.join(',')
      }
    },
    // 获取表单信息
    getDetail() {
      let list = localStorage.getItem("bis_UNQUALIFIEDS");
      this.handleList = JSON.parse(list);
      console.log(this.handleList, "this.handleList getDetail");
      // let a = this.handleList;
      this.handleList.forEach((item, i) => {
        item.failedProcessId = item.processId;
        item.faieldProcessIdText = item.processName;
        item.failedOperatorId = item.operatorId;
        item.failedOperatorIdText = item.operatorId.split(',');
        item.failedTaskId = item.taskId;
        this.getReportTeam(item, i)
      });
    },
    // 表单提交
    btnConfirm() {
      for (let i = 0; i < this.handleList.length; i++) {
        const item = this.handleList[i];
        if (!item.handleType) {
          this.$toast(`第${i + 1}条处理方式必填`);
          return;
        } else {
          if (!item.num) {
            this.$toast(`第${i + 1}条处理数量必填`);
            return;
          }
        }
      }
      this.loadingSubmit = true;
      messNotQualityHandleIinfoHandle(this.handleList).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message);
          this.$router.go(-1);
        } else {
          this.$toast(res.message);
        }
        this.loadingSubmit = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  color: #191f25;
  font-weight: bold;
  font-size: 0.16rem;
  padding: 0.15rem;
  margin: 0;
}
@import "@/assets/theme.scss";
@import "@/views/workManagement/materialRequisition/materialForm.scss";
.search-bottoms {
  width: 100%;
  height: 0.5rem;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0rem 0.11rem;
  box-sizing: border-box;
  font-size: 0.16rem;
  font-weight: 500;
  z-index: 9;
  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 0.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.03rem;
    color: #ffffff;
  }
}
</style>
